import { NavigateFunction } from 'react-router-dom';

// Public paths
export const HOME_PATH = '/home';

export const LOGIN_PATH = '/login';
export const ONBOARDING_PATH = '/onboarding';
export const CREATE_ACCOUNT_PATH = '/create-account';

// Private paths

export const PRE_PRIVATE_PATH = ''; // <---- this goes befere all routes
export const ADMIN_HOME_PATH = PRE_PRIVATE_PATH + '/';
export const METRICS_PATH = PRE_PRIVATE_PATH + '/metrics';
export const RESERVATION_PATH = PRE_PRIVATE_PATH + '/reservations/:id';
export const RESERVATION_PRINT_PATH = PRE_PRIVATE_PATH + '/reservations/:id/print';
export const RESERVATIONS_PATH = PRE_PRIVATE_PATH + '/reservations';
export const RESERVATIONS_EXPORT_PATH = PRE_PRIVATE_PATH + '/reservations-export';
export const RESERVATIONS_NEW_PATH = PRE_PRIVATE_PATH + '/reservations/new';
export const PERSONS_PATH = PRE_PRIVATE_PATH + '/persons';
export const PERSON_PATH = PRE_PRIVATE_PATH + '/persons/:id';
export const PERSONS_NEW_PATH = PRE_PRIVATE_PATH + '/persons/new';
export const BUSINESSES_PATH = PRE_PRIVATE_PATH + '/businesses';
export const MY_BUSINESSES_PATH = PRE_PRIVATE_PATH + '/my-businesses';
export const BUSINESS_PATH = PRE_PRIVATE_PATH + '/businesses/:id';
export const SERVICES_TABLE_PATH = PRE_PRIVATE_PATH + '/services-table';
export const SERVICES_PATH = PRE_PRIVATE_PATH + '/services';
export const SERVICE_PATH = PRE_PRIVATE_PATH + '/services/:id';
export const SERVICE_RANK_PATH = PRE_PRIVATE_PATH + '/service-ranking';
export const SERVICE_GROUPS_PATH = PRE_PRIVATE_PATH + '/service-groups';
export const SERVICE_GROUP_PATH = PRE_PRIVATE_PATH + '/service-groups/:id';
export const PRODUCTS_PATH = PRE_PRIVATE_PATH + '/products';
export const PRODUCT_PATH = PRE_PRIVATE_PATH + '/products/:id';
export const ORDERS_SHOW_PATH = PRE_PRIVATE_PATH + '/orders-show';
export const ORDERS_LIST_V2_PATH = PRE_PRIVATE_PATH + '/service-orders-v2';
export const ORDERS_CREATE_PATH = PRE_PRIVATE_PATH + '/orders-create';
export const SERVICE_ORDERS_PATH = PRE_PRIVATE_PATH + '/service-orders';
export const ASSIGNMENTS_PATH = PRE_PRIVATE_PATH + '/assignments';
export const SERVICE_ORDER_PATH = PRE_PRIVATE_PATH + '/service-orders/:id';
export const MANIFEST_SERVICE_ORDER_PATH = PRE_PRIVATE_PATH + '/service-orders/:id/manifest';
export const EDIT_SERVICE_ORDER_PATH = PRE_PRIVATE_PATH + '/service-orders/:id';
export const SERVICE_BOOKINGS_PATH = PRE_PRIVATE_PATH + '/service-bookings';
export const SERVICE_BOOKING_PATH = PRE_PRIVATE_PATH + '/service-bookings/:id';

export const OPERATIONS_PATH = PRE_PRIVATE_PATH + '/operations';
export const FLIGHTS_PATH = PRE_PRIVATE_PATH + '/flights';
export const INVENTORY_ITEMS_PATH = PRE_PRIVATE_PATH + '/edit-inventory';
export const MONEY_TRANSACTIONS_PATH = PRE_PRIVATE_PATH + '/money-transactions';
export const PAYMENTS_PATH = PRE_PRIVATE_PATH + '/payments';
export const PAYMENTS_INCOME_PATH = PRE_PRIVATE_PATH + '/payments/income';
export const PAYMENTS_OUTCOME_PATH = PRE_PRIVATE_PATH + '/payments/outcome';
export const AGENDA_PATH = PRE_PRIVATE_PATH + '/agenda';
export const SUBSCRIPTIONS_PATH = PRE_PRIVATE_PATH + '/subscriptions';
export const MONEY_TRANSACTIONS_IN_PATH = PRE_PRIVATE_PATH + '/money-transactions/in';
export const MONEY_TRANSACTIONS_OUT_PATH = PRE_PRIVATE_PATH + '/money-transactions/out';
export const FINANCES_PATH = PRE_PRIVATE_PATH + '/finances';
export const BALANCE_PATH = PRE_PRIVATE_PATH + '/balance';
export const ISSUES_PATH = PRE_PRIVATE_PATH + '/issues';
export const HISTORY_PATH = PRE_PRIVATE_PATH + '/history';
export const FEED_PATH = PRE_PRIVATE_PATH + '/feed';
export const AI_CHAT_PATH = PRE_PRIVATE_PATH + '/ai-chat';
export const TICKETS_PATH = PRE_PRIVATE_PATH + '/tickets';
export const TICKET_PATH = PRE_PRIVATE_PATH + '/tickets/:id';
export const TICKET_NEW_PATH = PRE_PRIVATE_PATH + '/tickets/new';

export const EMAIL_CAMPAIGNS_PATH = PRE_PRIVATE_PATH + '/email-campaigns';
export const EMAIL_TEMPLATES_PATH = PRE_PRIVATE_PATH + '/email-templates';
export const EMAIL_TEMPLATE_PATH = PRE_PRIVATE_PATH + '/email-templates/:id';

// settings paths
export const SETTINGS_PATH = PRE_PRIVATE_PATH + '/settings';
export const SETTINGS_USERS_PATH = PRE_PRIVATE_PATH + '/settings/users';
export const SETTINGS_USER_EDIT_PATH = PRE_PRIVATE_PATH + '/settings/users/:id';
export const SETTINGS_CHANGE_PASSWORD_PATH = PRE_PRIVATE_PATH + '/settings/change-password';
export const SETTINGS_ONLINE_STORE_PATH = PRE_PRIVATE_PATH + '/settings/online-store';
export const SETTINGS_LANGUAGE_PATH = PRE_PRIVATE_PATH + '/settings/language';
export const SETTINGS_EXCHANGE_RATES_PATH = PRE_PRIVATE_PATH + '/settings/exchange-rates';
export const SETTINGS_DISCOUNT_CATEGORIES_PATH = PRE_PRIVATE_PATH + '/settings/discount-categories';
export const SETTINGS_SERVICE_ORDERS_PATH = PRE_PRIVATE_PATH + '/settings/service-orders';
export const SETTINGS_TAX_SETTINGS_PATH = SETTINGS_PATH + '/tax-settings';
export const SETTINGS_NOTIFICATIONS_PATH = SETTINGS_PATH + '/notifications-settings';
export const SETTINGS_EMAILS_PATH = SETTINGS_PATH + '/emails';
export const SETTINGS_GMAIL_PATH = SETTINGS_PATH + '/gmail';
export const AFIP_HISTORY_PATH = PRE_PRIVATE_PATH + '/afip-history';
export const AFIP_GENERATE_PATH = PRE_PRIVATE_PATH + '/afip-generate';
export const TARIFFS_PATH = PRE_PRIVATE_PATH + '/tariffs';

export const SEARCH_PATH = PRE_PRIVATE_PATH + '/search';


export const paramsToString = (params?: Record<string, string | number>) => {
    if (!params) return '';

    const filteredEntries = Object.entries(params)
        .filter(([_, value]) => value !== null && value !== undefined)
        .map(([key, value]) => [key, value.toString()]);

    if (filteredEntries.length === 0) return '';

    const aux = `?${new URLSearchParams(filteredEntries).toString()}`;
    return aux;
};

// Store the navigate function
let navigateRef: NavigateFunction | null = null;

export const initNavigate = (navigate: NavigateFunction) => {
    navigateRef = navigate;
};

/**
 * Ensures the navigation path is strictly an internal, same-origin relative path,
 * preventing open redirects via protocol-relative URLs (e.g. '//evil.com' or '/\\evil.com').
 */
export const getSafeInternalPath = (rawPath: string): string => {
    if (!rawPath || typeof rawPath !== 'string') {
        return '/';
    }

    // Strip leading slashes/backslashes to eliminate protocol-relative prefixes
    const cleanPath = rawPath.replace(/^[\/\\]+/, '');
    const normalized = `/${cleanPath}`;

    // Additional defense: disallow protocol-relative URLs and absolute URLs
    if (normalized.startsWith('//') || normalized.startsWith('/\\')) {
        return '/';
    }

    try {
        const parsed = new URL(normalized, window.location.origin);
        if (parsed.origin === window.location.origin) {
            return `${parsed.pathname}${parsed.search}${parsed.hash}`;
        }
    } catch {
        // Fallback on invalid URL
    }

    return '/';
};

export const navigate = (path: string, openTab: boolean = false) => {
    const safePath = getSafeInternalPath(path);
    if (document.location.pathname === safePath) {
        return;
    }
    if (!navigateRef) {
        console.warn('Navigation not initialized, falling back to window.location');
        window.location.href = safePath;
        return;
    }
    window.scrollTo(0, 0);
    if (openTab) {
        window.open(safePath, '_blank');
    } else {
        navigateRef(safePath);
    }
};

export const navTo = (path: string, params?: Record<string, string | number>, openTab?: boolean) => {
    const url = path.replace(/:([^/]+)/g, (match, param) => params?.[param]?.toString() || match);
    navigate(url, openTab);
};

export const gotoHome = () => {
    navigate(HOME_PATH);
};


export const gotoReservations = (params?: Record<string, string | number>) => {
    navigate(RESERVATIONS_PATH + paramsToString(params));
};

export const gotoReservationsExport = (params?: Record<string, string | number>) => {
    navigate(RESERVATIONS_EXPORT_PATH + paramsToString(params));
};

export const gotoReservation = (id: number | string) => {
    window.open(RESERVATION_PATH.replace(':id', id.toString()), '_blank');
};

export const gotoService = (id: number | string) => {
    navigate(SERVICE_PATH.replace(':id', id.toString()));
};

export const gotoServices = () => {
    navigate(SERVICES_PATH);
};

export const gotoServiceRanking = () => {
    navigate(SERVICE_RANK_PATH);
};

export const gotoReservationsNew = () => {
    navigate(RESERVATIONS_NEW_PATH);
};

export const gotoPersons = () => {
    navigate(PERSONS_PATH);
};

export const gotoPersonsNew = () => {
    navigate(PERSONS_NEW_PATH);
};

export const gotoPerson = (id: string | number) => {
    navigate(PERSON_PATH.replace(':id', id.toString()));
};

export const gotoBusinessess = () => {
    navigate(BUSINESSES_PATH);
};

export const gotoMyBusinesses = () => {
    navigate(MY_BUSINESSES_PATH);
};

export const gotoBusiness = (id: string | number) => {
    navigate(BUSINESS_PATH.replace(':id', id.toString()));
};

export const gotoServiceOrders = (params?: Record<string, string | number>) => {
    navigate(ORDERS_SHOW_PATH + paramsToString(params));
};

export const gotoServiceOrder = (id: string | number) => {
    navigate(SERVICE_ORDER_PATH.replace(':id', id.toString()));
};
export const gotoServiceOrderEdit = (id: string | number) => {
    navigate(EDIT_SERVICE_ORDER_PATH.replace(':id', id.toString()));
};
export const gotoInventoryItems = () => {
    navigate(INVENTORY_ITEMS_PATH);
};

export const gotoServiceOrdersMatrix = () => {
    navigate(OPERATIONS_PATH);
};

export const gotoAssignments = () => {
    navigate(ASSIGNMENTS_PATH);
};

export const gotoTariffs = () => {
    navigate(TARIFFS_PATH);
};

export const gotoProducts = () => {
    navigate(PRODUCTS_PATH);
};

export const gotoProduct = (id: string | number) => {
    navigate(PRODUCT_PATH.replace(':id', id.toString()));
};

export default {
    initNavigate,
    gotoHome,
    gotoReservations,
    gotoReservationsExport,
    gotoReservation,
    gotoService,
    gotoServices,
    gotoServiceRanking,
    gotoReservationsNew,
    gotoPersons,
    gotoPersonsNew,
    gotoPerson,
    gotoBusinessess,
    gotoMyBusinesses,
    gotoBusiness,
    gotoServiceOrders,
    gotoServiceOrder,
    gotoServiceOrderEdit,
    gotoInventoryItems,
    gotoServiceOrdersMatrix,
    gotoAssignments,
    gotoTariffs,
    gotoProducts,
    gotoProduct,
};